import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 9l3 3l-3 3","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","key":"svg-1"}]]

/**
 * IconCircleChevronRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2lyY2xlLWNoZXZyb24tcmlnaHQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTExIDlsMyAzbC0zIDMiIC8+CiAgPHBhdGggZD0iTTMgMTJhOSA5IDAgMSAwIDE4IDBhOSA5IDAgMCAwIC0xOCAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/circle-chevron-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCircleChevronRight = createReactComponent('outline', 'circle-chevron-right', 'CircleChevronRight', __iconNode);

export default IconCircleChevronRight;